import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { QuillModules } from 'ngx-quill';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';
import { UniversityService } from 'src/app/core/services/university/university.service';

@Component({
    selector: 'app-greenwich-form-new',
    templateUrl: './greenwich-form-new.component.html',
    styleUrls: ['./greenwich-form-new.component.scss'],
})
export class GreenwichFormNewComponent implements OnInit {
    @Input() interviewForm: FormGroup | any;
    @Input() showOnlyTemplate: boolean = false;
    @Input() questions: any = null;
    @Output() formSubmit: EventEmitter<any> = new EventEmitter<any>();

    QuillModules: QuillModules = {
        toolbar: [
            // default value
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
            [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
            [{ direction: 'rtl' }], // text direction
            [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],
            ['clean'], // remove formatting button
            ['link', 'image', 'video'], // link and image, video
        ],
    };

    radioQuestionArr: any = [
        {
            type: 'radio',
            labelName: 'Common Questions',
            categoryName: 'Common',
            isRequired: true,
            question: 'Is the student giving interview is same as in passport?',
            options: [
                {
                    id: 'passport_check1',
                    name: 'passport_check',
                    value: 'Y',
                    label: 'Yes',
                },
                {
                    id: 'passport_check2',
                    name: 'passport_check',
                    value: 'N',
                    label: 'No',
                },
                {
                    id: 'passport_check3',
                    name: 'passport_check',
                    value: 'Doubtful',
                    label: 'Doubtful',
                },
            ],
            subQuestions: [
                {
                    labelName: 'Doubtful Questions',
                    categoryName: 'Doubtful',
                    id: 'Doubtful',
                    type: 'radio',
                    isRequired: true,
                    question: 'Please confirm your Date of Birth',
                    options: [
                        {
                            id: 'doubt_dob1',
                            name: 'doubt_dob',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'doubt_dob2',
                            name: 'doubt_dob',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
                {
                    labelName: 'Doubtful Questions',
                    categoryName: 'Doubtful',
                    id: 'Doubtful',
                    type: 'radio',
                    isRequired: true,
                    question: 'Please tell me your place of birth',
                    options: [
                        {
                            id: 'doubt_dobplace1',
                            name: 'doubt_dobplace',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'doubt_dobplace2',
                            name: 'doubt_dobplace',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
            ],
            subQuestionLabel: {
                label: 'Doubtful Questions',
                categoryName: 'Doubtful',
            },
        },
        {
            labelName: 'Common Questions',
            categoryName: 'Common',
            type: 'radio',
            isRequired: true,
            question:
                'The interview will take approximately 30 minutes. Are you feeling fit and well enough to be interviewed today?',
            options: [
                {
                    id: 'interview_ans1',
                    name: 'interview_ans',
                    value: 'Answered',
                    label: 'Answered',
                },
                {
                    id: 'interview_ans2',
                    name: 'interview_ans',
                    value: 'Not Answered',
                    label: 'Not Answered',
                },
            ],
        },
        {
            labelName: 'Common Questions',
            categoryName: 'Common',
            type: 'radio',
            isRequired: true,
            question:
                'Can you hear me clearly and understand what I am saying?',
            options: [
                {
                    id: 'hear_me1',
                    name: 'interview_ans',
                    value: 'Answered',
                    label: 'Answered',
                },
                {
                    id: 'hear_me2',
                    name: 'interview_ans',
                    value: 'Not Answered',
                    label: 'Not Answered',
                },
            ],
        },
        {
            labelName: 'Common Questions',
            categoryName: 'Common',
            type: 'radio',
            isRequired: true,
            question:
                'Please can you tell me your full name and date of birth?',
            options: [
                {
                    id: 'birth_ans1',
                    name: 'birth_ans',
                    value: 'Answered',
                    label: 'Answered',
                },
                {
                    id: 'birth_ans1',
                    name: 'birth_ans',
                    value: 'Not Answered',
                    label: 'Not Answered',
                },
            ],
        },
        {
            labelName: 'Common Questions',
            categoryName: 'Common',
            type: 'radio',
            isRequired: true,
            question:
                'Which course have you applied to study at University of Greenwich?',
            options: [
                {
                    id: 'appliedstudy_ans1',
                    name: 'appliedstudy',
                    value: 'Answered',
                    label: 'Answered',
                },
                {
                    id: 'appliedstudy_ans2',
                    name: 'appliedstudy',
                    value: 'Not Answered',
                    label: 'Not Answered',
                },
            ],
        },
        {
            labelName: 'Common Questions',
            categoryName: 'Common',
            type: 'radio',
            isRequired: true,
            question:
                'I am going to be typing my questions and your answers down therefore I need you to speak slowly and clearly for me. If at any point you are speaking too fast, I will ask you to stop slow down and repeat what you just said. Is this okay?',
            options: [
                {
                    id: 'type_qus1',
                    name: 'type_qus',
                    value: 'Answered',
                    label: 'Answered',
                },
                {
                    id: 'type_qus2',
                    name: 'type_qus',
                    value: 'Not Answered',
                    label: 'Not Answered',
                },
            ],
        },
    ];

    decisionQuestionArr: any = [
        {
            primary: {
                heading: 'Decision',
                label: 'Decision Questions',
                categoryName: 'Decision',
            },
            questions: [
                {
                    type: 'radio',
                    labelName: 'Decision Questions',
                    categoryName: 'Decision',
                    isRequired: true,
                    question: 'Have you understood all the questions?',
                    options: [
                        {
                            id: 'all_ans1',
                            name: 'all_ans',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'all_ans2',
                            name: 'all_ans',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
                {
                    labelName: 'Decision Questions',
                    categoryName: 'Decision',
                    type: 'radio',
                    isRequired: true,
                    question: 'Is there anything else you wish to add?',
                    options: [
                        {
                            id: 'anything_else1',
                            name: 'anything_else',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'anything_else2',
                            name: 'anything_else',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },

                {
                    labelName: 'Decision Questions',
                    categoryName: 'Decision',
                    type: 'radio',
                    isRequired: true,
                    question:
                        'Are you happy with the conduct of the interview?',
                    options: [
                        {
                            id: 'int_happy1',
                            name: 'anything_else',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'int_happy2',
                            name: 'int_happy',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
            ],
        },
    ];

    interviewQuestions: any = [
        {
            primary: {
                heading: 'Interview Questions',
                label: 'Interview Questions',
                categoryName: 'Interview',
                decisions: [
                    { value: 'R', label: 'R' },
                    { value: 'A', label: 'A' },
                    { value: 'G', label: 'G' },
                ],
            },
            questionList: [
                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question: 'Why did you choose the University of Greenwich?',
                    questionNo: '1',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'University details known',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Evidence of research',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Vague/Generic answer',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Lack of university knowledge',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question: 'What do you know about University of Greenwich?',
                    questionNo: 'a',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'University details known',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Lack of university knowledge',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question:
                        'Where did you find information about Greenwich, and how did this influence your decision?',
                    questionNo: 'b',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Evidence of research',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Vague/generic answer',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question:
                        'Did anyone help you make your decision to study at Greenwich?',
                    questionNo: 'c',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: '',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Too much Agent influence',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    label: 'COMPULSORY QUESTION - failure to give a credible answer will result in an instant 2nd interview',
                    question:
                        'What other UK universities could you have chosen? Why didn’t you?',
                    questionNo: 'd',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'List alternatives considered',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'Explains why this university is a better fit',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Evidence of research',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'No alternatives considered',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Too much Agent influence',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question: 'Why did you choose to study in the UK?',
                    questionNo: 'e',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Benefits specific to UK',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Details of course included',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Details of institution',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Non-study benefits only',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    label: 'COMPULSORY QUESTION - failure to give a credible answer will result in an instant 2nd interview',
                    question:
                        'Do you know the position of Greenwich in UK university league table? Where did you find this?',
                    questionNo: 'f',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Realistic response',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Compared to other Universities',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Unrealistic/no response',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question: 'Why did you choose your course?',
                    questionNo: '2',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Course content details',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Evidence of research',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Logical next step',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Required for future plans',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'Knowledge of what the course entails',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Vague/Generic answer',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Lack of course knowledge',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'No clear need to studyLack of course knowledge',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'Unable to provide a description of what the course entails',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question: 'Do you know how much your course will cost?',
                    questionNo: 'a',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'Able to give a realistic estimate or exact cost',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Not able to give realistic figure',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question:
                        'Do you know which campus you will be studying at and would you be able to find it on a map?',
                    questionNo: 'b',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Realistic Response',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'No/Unrealistic response',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },
                //3
                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question: 'Where do you plan to live in the UK?	',
                    questionNo: '3',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Location of accommodation',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Details of accommodation',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Unrealistic location/response',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question:
                        'What are the advantages and disadvantages of this type of accommodation?	',
                    questionNo: 'a',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Evidence of research',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Vague/generic response	',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question:
                        'How much will accommodation cost? Think about your monthly budget.	',
                    questionNo: 'b',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Accurate knowledge',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'Considered costs in plans and finances	',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Incorrect or lack of knowledge',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Overreliance on work',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },
                //4
                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question:
                        'How do you intendto travel betweenthe campus and youraccommodation?',
                    questionNo: '4',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Realistic Response',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'No/Unrealistic response',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question: 'How do people travel around?',
                    questionNo: 'a',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'Different modes of transport are given',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'No/Unrealistic response',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question:
                        'Do you know how much you are likely to spend travelling to university?',
                    questionNo: 'b',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Any costs given accurate',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'High costs not accounted for',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question: 'Do you know about student travel discounts?',
                    questionNo: 'c',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Realistic response',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'Will consider looking into it further',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'High costs not accounted for',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question: 'How will you fund your studies?',
                    label: 'COMPULSORY QUESTION – failure to give a credible answer will result in an instant 2nd interview',
                    questionNo: '5',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Sustainable source of income',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Credible source of income',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Evidence available	',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Evidence available	',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'High costs not accounted for',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'No evidence of income stated',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Overreliance on work in UK',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question:
                        'How much money will you need to live in the UK? Where did you find this information?',
                    questionNo: 'a',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Accurate knowledge',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'Considered costs in plans and finances',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Incorrect or lack of knowledge',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Overreliance on work',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question:
                        'Are you planning to work part-time while you are studying? Do you know what the restrictions are?',
                    questionNo: 'b',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'UKVI guidelines mentioned',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Unrealistic/no response	',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question:
                        'How will you fund your subsequent year’s fees (if course is longer than a year)?',
                    questionNo: 'c',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Sustainable source of income',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Credible source of income',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Evidence available',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'Unsustainable or non-credible source of income',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'No evidence of income stated',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Overreliance on work in UK',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    label: 'COMPULSORY QUESTION – failure to give a credible answer will result in an instant 2nd interview',
                    question:
                        'How will your course help with your future plans?',
                    questionNo: '6',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Clear plan for after study',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Realistic plans relevant to study',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'States why course is needed to achieve those plans',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'No/unrealistic plans',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'No clear plan to achieve aim',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'Could be achieved without this course',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'No/unrealistic plans',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question:
                        'What do you think you will be doing in ten years’ time?',
                    questionNo: 'a',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Realistic plans relevant to study',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'No/unrealistic plans',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    label: 'COMPULSORY QUESTION – failure to give a credible answer will result in an instant 2nd interview',
                    question: 'How much do you expect to be earning?',
                    questionNo: 'b',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Realistic response',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Evidence of research',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'No/unrealistic plans',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Lack of research',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    label: '',
                    question: 'How will your experience outside of the classroom help you?',
                    questionNo: 'c',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Explains other aspects other than course modules (e.g. confidence)',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            // {
                            //     labelName: 'Interview Sub Questions',
                            //     questions: 'Evidence of research',
                            //     answerType: 'radio',
                            //     options: [
                            //         { label: 'Yes', value: 'Y' },
                            //         { label: 'No', value: 'N' },
                            //     ],
                            // },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Could be achieved without this course',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            // {
                            //     labelName: 'Interview Sub Questions',
                            //     questions: 'Lack of research',
                            //     answerType: 'radio',
                            //     options: [
                            //         { label: 'Yes', value: 'Y' },
                            //         { label: 'No', value: 'N' },
                            //     ],
                            // },
                        ],
                    ],
                },

                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    label: 'Questions depending on Checklist:',
                    question:
                        'You have previously studied in the UK – why have you chosen to return?',
                    questionNo: '7',
                    answerType: 'textarea',
                    subQuestions:   [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'Demonstrates a clear need to return to study now',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Consistent with prior information',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'No logical reason to return to study now',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Inconsistent with prior info',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    label: '',
                    question:
                        'You have had a long break in your studies, why are you returning to study now?',
                    questionNo: 'b',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Sound explanation of reason',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'Demonstrates a clear need to return to study now',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Consistent with prior information',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'Could be achieved without this course',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    label: '',
                    question:
                        'Do you plan on bringing dependents? If yes, how do you plan on financially supporting them?',
                    questionNo: 'c',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Primary focus on study',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions:
                                    'Explanation of how the situation will be managed',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Consistent with prior information',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Commitments at home',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'No clear plans for support',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Inconsistent with prior info',
                                answerType: 'radio',
                                options: [
                                    { label: 'Yes', value: 'Y' },
                                    { label: 'No', value: 'N' },
                                ],
                            },
                        ],
                    ],
                },
            ],
        },
    ];

    compulsoryQuestions: any = [
        {
            primary: {
                heading: 'Compulsory Questions',
                label: 'Compulsory Questions',
                categoryName: 'Compulsory',
                decisions: [
                    {
                        value: 'R',
                        label: 'R',
                    },
                    {
                        value: 'A',
                        label: 'A',
                    },
                    {
                        value: 'G',
                        label: 'G',
                    },
                ],
            },

            questionList: [
                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question: 'Why did you choose the University of Greenwich?',
                    questionNo: '1',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'University details known',
                                answerType: 'radio',
                                options: [
                                    {
                                        label: 'Yes',
                                        value: 'Y',
                                    },
                                    {
                                        label: 'No',
                                        value: 'N',
                                    },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Evidence of research',
                                answerType: 'radio',
                                options: [
                                    {
                                        label: 'Yes',
                                        value: 'Y',
                                    },
                                    {
                                        label: 'No',
                                        value: 'N',
                                    },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Vague/Generic answer',
                                answerType: 'radio',
                                options: [
                                    {
                                        label: 'Yes',
                                        value: 'Y',
                                    },
                                    {
                                        label: 'No',
                                        value: 'N',
                                    },
                                ],
                            },
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Lack of university knowledge',
                                answerType: 'radio',
                                options: [
                                    {
                                        label: 'Yes',
                                        value: 'Y',
                                    },
                                    {
                                        label: 'No',
                                        value: 'N',
                                    },
                                ],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    categoryName: 'Interview',
                    question: 'What do you know about University of Greenwich?',
                    questionNo: 'a',
                    answerType: 'textarea',
                    subQuestions: [
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'University details known',
                                answerType: 'radio',
                                options: [
                                    {
                                        label: 'Yes',
                                        value: 'Y',
                                    },
                                    {
                                        label: 'No',
                                        value: 'N',
                                    },
                                ],
                            },
                        ],
                        [
                            {
                                labelName: 'Interview Sub Questions',
                                questions: 'Lack of university knowledge',
                                answerType: 'radio',
                                options: [
                                    {
                                        label: 'Yes',
                                        value: 'Y',
                                    },
                                    {
                                        label: 'No',
                                        value: 'N',
                                    },
                                ],
                            },
                        ],
                    ],
                },
            ],
        },
    ];

    additionalQuestions: any = [
        {
            questionList: [
                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question: '',
                    answerType: 'checkbox',
                    options: [
                        {
                            label: 'Pass',
                            id: '0',
                            value: 'Pass',
                        },
                        {
                            label: 'Fail',
                            id: '1',
                            value: 'Fail',
                        },
                        {
                            label: 'Fail And Reschedule',
                            id: '2',
                            value: 'Fail Reschedule',
                        },
                    ],
                },

                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question: 'Please include Feedback:',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question: 'How many interviews were undertaken?',
                    answerType: 'input',
                },
                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question: 'What areas did they have to improve on?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question: 'Can you hear me clearly?',
                    answerType: 'input',
                },
                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question: 'Is it a good time for the interview?',
                    answerType: 'input',
                },
                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question: 'Passport shown:',
                    answerType: 'input',
                },
                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question: 'Please indicate what region they are from :',
                    answerType: 'input',
                },
                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question: 'Any previous refusals (any country) :',
                    answerType: 'input',
                },
            ],
        },
    ];

    user_details: any;

    constructor(
        private _fb: FormBuilder,
        private _universityService: UniversityService,
        private _authenticationService: AuthenticationService
    ) {}

    ngOnInit(): void {
        this.user_details = this._authenticationService.getLoginUserDetails();
        this._universityService.submitForms.subscribe((res) => {
            if (res) this.onSubmit();
        });

        this.interviewForm = this._fb.group({
            radioQuestions: this._fb.array([]),
            decisionQuestions: this._fb.array([]),
            interviewQuestions: this._fb.array([]),
            additionalQuestions: this._fb.array([]),
        });

        this.initRadioQuestions();
        this.initInterviewQuestions();
        this.initAdditionalQuestions();
    }

    initAdditionalQuestions() {
        const control = <FormArray>(
            this.interviewForm.get('additionalQuestions')
        );
        this.additionalQuestions.forEach((q) => {
            const group = this._fb.group({
                additionalQuestionList: this._fb.array(
                    q.questionList.map((item, index) =>
                        this._fb.group({
                            question: [item.question],
                            answer: [
                                this.questions?.additionalQuestion[index]
                                    ?.answer || '',
                            ],
                        })
                    )
                ),
            });
            control.push(group);
        });
    }

    initRadioQuestions() {
        const control = this.interviewForm.get('radioQuestions') as FormArray;
        const decisionControl = this.interviewForm.get(
            'decisionQuestions'
        ) as FormArray;
        this.radioQuestionArr.forEach((q, index) => {
            const group = this._fb.group({
                question: [q.question],
                answer: [
                    this.questions?.radioData[index].answer || '',
                    Validators.required,
                ],
                subQuestions: this._fb.array([]),
            });
            control.push(group);
            if (
                this.questions?.radioData[index]?.subQuestions &&
                this.questions?.radioData[index]?.subQuestions.length > 0
            ) {
                this.onChanges(
                    group,
                    index,
                    this.questions?.radioData[index]?.subQuestions
                );
            }
        });
        this.decisionQuestionArr[0]?.questions.forEach((q, index) => {
            const group = this._fb.group({
                question: [q.question],
                answer: [
                    this.questions?.decisionRadioData[index].answer || '',
                    Validators.required,
                ],
            });
            decisionControl.push(group);
        });
    }

    onChanges(control: any, index: number = 0, subQuestions: any = {}): void {
        this.updateSubQuestions(control, index, subQuestions);
    }

    updateSubQuestions(
        control: FormGroup,
        index: number = 0,
        subQuestions: any = {}
    ) {
        const question = this.radioQuestionArr[index];
        const answer = control.get('answer').value;

        if (question.subQuestions) {
            const subControl = control.get('subQuestions') as FormArray;
            subControl.clear();

            if (question.options) {
                question.subQuestions
                    .filter((item) => item.id === answer)
                    .forEach((subQ, index) => {
                        const subGroup = this._fb.group({
                            question: [subQ.question],
                            answer: [subQuestions[index]?.answer || ''],
                        });
                        subControl.push(subGroup);
                    });
            }
        }
    }

    initInterviewQuestions() {
        const control = this.interviewForm.get(
            'interviewQuestions'
        ) as FormArray;
        this.interviewQuestions.forEach((q, index) => {
            const group = this._fb.group({
                interviewQuestionList: this._fb.array(
                    q.questionList.map((item, index) =>
                        this._fb.group({
                            question: [item.question],
                            answer: [
                                this.questions?.interviewQuestion[index]
                                    ?.answer || '',
                            ],
                            decision: [
                                this.questions?.interviewQuestion[index]
                                    ?.decision || '',
                            ],
                            subQuestions: this._fb.array(
                                item.subQuestions.map((subQuestion, subIndex) =>
                                    this._fb.array(
                                        subQuestion.map((sq, sqIndex) => {
                                            this.questions;
                                            return this._fb.group({
                                                answer: [
                                                    this.questions
                                                        ?.interviewQuestion[
                                                        index
                                                    ]?.subQuestions[subIndex][
                                                        sqIndex
                                                    ]?.answer || '',
                                                ],
                                                question: [sq?.questions],
                                            });
                                        })
                                    )
                                )
                            ),
                        })
                    )
                ),
            });
            control.push(group);
        });
    }

    onSubmit() {
        const radioData = this.interviewForm?.value?.radioQuestions.map(
            (element, index) => {
                return {
                    labelName: this.radioQuestionArr[index]?.labelName,
                    question: this.radioQuestionArr[index]?.question,
                    answer: element?.answer,
                    answerType: this.radioQuestionArr[index]?.type,
                    asnwerValues: this.radioQuestionArr[index]?.options.map(
                        (item) => {
                            return {
                                id: item?.id,
                                values: item?.label,
                            };
                        }
                    ),
                    categoryName: this.radioQuestionArr[index]?.categoryName,
                    optionalFields: [],
                    subQuestions: this.radioQuestionArr[
                        index
                    ]?.subQuestions?.map((item, subIndex) => {
                        return {
                            labelName:
                                this.radioQuestionArr[index]?.subQuestionLabel
                                    ?.label,
                            questions: item?.question,
                            categoryName: item?.categoryName,
                            answer: element.subQuestions[subIndex]?.answer,
                            answerType: item?.type,
                            answerValues: item.options.map((item) => {
                                return {
                                    id: item?.id,
                                    values: item?.label,
                                };
                            }),
                            optionalFields: [],
                        };
                    }),
                };
            }
        );

        const interviewQuestion =
            this.interviewForm?.value?.interviewQuestions[0].interviewQuestionList.map(
                (element, index) => {
                    const questionData =
                        this.interviewQuestions[0]?.questionList[index];

                    return {
                        labelName: questionData?.labelName,
                        question: questionData?.question,
                        questionNo: questionData?.questionNo,
                        label: questionData?.label || '',
                        answer: element?.answer,
                        decision: element?.decision,
                        answerType: questionData?.answerType,
                        answerValues:
                            this.interviewQuestions[0]?.primary.decisions?.map(
                                (item) => ({
                                    id: item?.value,
                                    values: item?.value,
                                })
                            ),
                        categoryName: questionData?.categoryName,
                        optionalFields: [],
                        subQuestions: questionData?.subQuestions.map(
                            (subQuestion, subIndex) => {
                                return subQuestion.map((sub, subQIndex) => {
                                    console.log(
                                        element?.subQuestions[subIndex][
                                            subQIndex
                                        ]
                                    );
                                    return {
                                        labelName: `Subquestion ${
                                            subIndex + 1
                                        }`, // You can adjust this as needed
                                        question: sub.questions,
                                        answer: element?.subQuestions[subIndex][
                                            subQIndex
                                        ]?.answer,
                                        answerType: sub.answerType,
                                        answerValues:
                                            sub.options?.map((option) => ({
                                                id: option.value,
                                                values: option.value,
                                            })) || [],
                                        optionalFields: [],
                                    };
                                });
                            }
                        ),
                    };
                }
            );

        const decisionRadioData =
            this.interviewForm?.value?.decisionQuestions.map(
                (element, index) => {
                    return {
                        labelName:
                            this.decisionQuestionArr[0]?.questions[index]
                                ?.labelName,
                        question:
                            this.decisionQuestionArr[0]?.questions[index]
                                ?.question,
                        answer: element?.answer,
                        answerType:
                            this.decisionQuestionArr[0]?.questions[index]?.type,
                        asnwerValues: this.decisionQuestionArr[0]?.questions[
                            index
                        ].options.map((item) => {
                            return {
                                id: item?.id,
                                values: item?.label,
                            };
                        }),
                        categoryName:
                            this.decisionQuestionArr[0]?.questions[index]
                                .categoryName,
                        optionalFields: [],
                        subQuestions: [],
                    };
                }
            );

        const additionalQuestion =
            this.interviewForm?.value?.additionalQuestions[0].additionalQuestionList.map(
                (element, index) => {
                    return {
                        labelName:
                            this.additionalQuestions[0]?.questionList[index]
                                ?.labelName,
                        question: element?.question,
                        answer: element?.answer,
                        answerType:
                            this.additionalQuestions[0]?.questionList[index]
                                ?.answerType,
                        asnwerValues:
                            this.additionalQuestions[0]?.questionList[index]
                                ?.answerType === 'checkbox'
                                ? this.additionalQuestions[0]?.questionList[
                                      index
                                  ].options.map((item) => {
                                      return {
                                          id: item?.value,
                                          values: item?.value,
                                      };
                                  })
                                : [],
                        categoryName:
                            this.additionalQuestions[0]?.questionList[index]
                                .categoryName,
                        optionalFields: [],
                        subQuestions: [],
                    };
                }
            );

        // const questions = [
        //     ...radioData,
        //     ...decisionRadioData,
        //     ...interviewQuestion,
        //     ...additionalQuestion,
        // ];

        const questions = {
            radioData,
            decisionRadioData,
            interviewQuestion,
            additionalQuestion,
        };

        this.formSubmit.emit({
            questions,
        });
    }
}
